/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'quote': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M33 13H15c-1.65 0-3 1.35-3 3v11c0 1.65 1.35 3 3 3h2v6l6-6h10c1.65 0 3-1.35 3-3V16c0-1.65-1.35-3-3-3zm-15 7.45c-1 .376-1.322 1.55-1.322 2.55H18v3h-3v-3.305c0-1.958 1-3.453 3-3.695v1.45zm4 0c-1 .376-1.326 1.55-1.326 2.55H22v3h-3v-3.305c0-1.958 1-3.453 3-3.695v1.45zm7-1.085c0 1.958-1 3.451-3 3.692v-1.45C27 21.234 27.451 20 27.451 19H26v-3h3v3.365zm4 0c0 1.958-1 3.451-3 3.692v-1.45C31 21.234 31.327 20 31.327 19H30v-3h3v3.365z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/quote.js